import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { setAuthToken } from '@/lib/axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Session ID manquant');
          navigate('/');
          return;
        }

        // Exchange session_id for user data and session_token
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        }, {
          withCredentials: true
        });

        const { user, session_token } = response.data;

        // Store session token BEFORE navigation (critical for Safari)
        if (session_token) {
          setAuthToken(session_token);
          localStorage.getItem('session_token'); // Force flush
          console.log('[AuthCallback] Token stored');
        }

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Small delay for Safari localStorage persistence
        await new Promise(resolve => setTimeout(resolve, 100));

        // Navigate to dashboard with user data and session_token
        navigate('/dashboard', { 
          state: { user, session_token }, 
          replace: true 
        });
        toast.success(`Bienvenue ${user.name || user.email} !`);
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Erreur d\'authentification');
        navigate('/');
      } finally {
        setIsProcessing(false);
      }
    };

    processSession();
  }, [navigate]);

  if (!isProcessing) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#030305]">
      <div className="text-center">
        <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-cyan-500 border-t-transparent"></div>
        <p className="mt-4 text-cyan-400 font-['Rajdhani']">Authentification en cours...</p>
      </div>
    </div>
  );
}
